const toggleDietaryRequirement = (state, requirement) => {
  let diet = [...state.diet]
  const index = diet.indexOf(requirement)

  if (index === -1) diet.push(requirement)
  else diet.splice(index, 1)

  return { ...state, diet }
}

const Reducer = (state = { meals: 5, servings: 2, diet: [] }, action) => {
  switch (action.type) {
    case 'SET_SETTINGS':
      return action.settings
    case 'SET_MEALS':
      return { ...state, meals: action.meals }
    case 'SET_SERVINGS':
      return { ...state, servings: action.servings }
    case 'TOGGLE_DIETARY_REQUIREMENT':
      return toggleDietaryRequirement(state, action.requirement)
    default:
      return state
  }
}

export default Reducer
